import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CustomModal from "./CustomModal";
import axios from "axios";
import "./style.css";
import { jwtDecode } from "jwt-decode";
import secureLocalStorage from "react-secure-storage";
import { createEventInCalender } from "../../../context/Slice/CalenderSlice";
import { useDispatch, useSelector } from "react-redux";
const {
  ShowVendorCalenderEvents,
} = require("../../../context/Slice/CalenderSlice");

const localizer = momentLocalizer(moment);

const MyCalendar = () => {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newEvent, setNewEvent] = useState({
    title: "",
    description: "",
    start: "",
    end: "",
  });
  const [showEventModal, setShowEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(
    moment().startOf("month").toDate()
  );
  const data = useSelector((state) => state.CalenderR.Data);
  const dispatch = useDispatch();
  const token = secureLocalStorage.getItem("token");
  console.log("token", token);
  let ID;
  let role;
  if (token) {
    const decoded = jwtDecode(token);
    ID = decoded._id;
    role = decoded.role;
    console.log(ID, role);
  }

  useEffect(() => {
    fetchEvents();
  }, []);

  console.log("data---------------...........>", data);

  const fetchEvents = async () => {
    try {
      // const response = await axios.get(`http://localhost:5000/api/v1/Calender/show-vendor-Events/${ID}`);
      // console.log("calendar detail", response.data.data.events);
      // let data = response.data.data.events;
      await dispatch(ShowVendorCalenderEvents(ID));
      const formattedEvents = data.map((event) => ({
        id: event.id,
        title: event.Title,
        description: event.Description,
        start: new Date(event.Start_Date),
        end: new Date(event.End_Date),
        allDay: event.Whole_day,
        serviceName: event.serviceName,
        coordinator_id: event.coordinator_id,
        vendor_id: event.vendor_id,
        status: event.Status,
      }));
      setEvents(formattedEvents);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const handleSelectSlot = ({ start, end }) => {
    setNewEvent({ title: "", description: "", start, end });
    setShowModal(true);
  };

  const handleDateChange = (e, type) => {
    const date = new Date(e.target.value);
    setNewEvent({ ...newEvent, [type]: date });
  };

  const handleAddEvent = async () => {
    const isOverlap = events.some((event) => {
      return (
        (newEvent.start >= event.start && newEvent.start < event.end) ||
        (newEvent.end > event.start && newEvent.end <= event.end) ||
        (newEvent.start <= event.start && newEvent.end >= event.end)
      );
    });

    if (role == "VENDOR") {
      newEvent.vendor_id = ID;
    } else {
      newEvent.coordinator_id = ID;
    }

    console.log("new Events:", newEvent);

    if (isOverlap) {
      alert(
        "This time slot is already booked. Please choose a different time."
      );
    } else {
      dispatch(createEventInCalender(newEvent));
    }
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setShowEventModal(true);
  };

  const handleCloseEventModal = () => {
    setShowEventModal(false);
    setSelectedEvent(null);
  };

  const handleViewChange = (view) => {
    if (view === "month") {
      const visibleMonth = moment().startOf("month").toDate();
      setCurrentMonth(visibleMonth);
    }
  };

  const handleNavigate = (date) => {
    setCurrentMonth(moment(date).startOf("month").toDate());
  };

  const currentMonthEvents = events.filter((event) => {
    const eventMonth = moment(event.start).startOf("month").toDate();
    const currentMonthStart = moment(currentMonth).startOf("month").toDate();
    const currentMonthEnd = moment(currentMonth).endOf("month").toDate();
    return event.start >= currentMonthStart && event.start <= currentMonthEnd;
  });

  return (
    <div className="calender-body">
      <h1 className="calendar-heading">Check your scheduled events</h1>
      <div id="calendar-container">
        <div id="sidebar">
          <h3>Your Events This Month</h3>
          <ul>
            {currentMonthEvents.map((event) => (
              <li
                key={event.id}
                onClick={() => handleEventClick(event)}
                style={{ cursor: "pointer" }}
              >
                {event.title} - {moment(event.start).format("MMMM Do")}
              </li>
            ))}
          </ul>
        </div>
        <div id="calendar">
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            selectable
            style={{ height: 500 }}
            onSelectSlot={handleSelectSlot}
            onSelectEvent={handleEventClick}
            onView={handleViewChange}
            onNavigate={handleNavigate}
          />
        </div>

        <CustomModal show={showModal} onClose={() => setShowModal(false)}>
          <h2>Add Event</h2>
          <form>
            <div>
              <label>Event Title</label>
              <input
                type="text"
                placeholder="Enter event title"
                value={newEvent.Title}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, Title: e.target.value })
                }
              />
            </div>
            <div>
              <label>Description</label>
              <input
                type="text"
                placeholder="Enter event description"
                value={newEvent.Description}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, Description: e.target.value })
                }
              />
            </div>
            <div>
              <label>Service Name</label>
              <input
                type="text"
                placeholder="Enter service name"
                value={newEvent.serviceName}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, serviceName: e.target.value })
                }
              />
            </div>
            <div>
              <label>Start Date</label>
              <input
                type="datetime-local"
                value={newEvent.Start_Date}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, Start_Date: e.target.value })
                }
              />
            </div>
            <div>
              <label>End Date</label>
              <input
                type="datetime-local"
                value={newEvent.End_Date}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, End_Date: e.target.value })
                }
              />
            </div>
            <div>
              <label>Whole Day</label>
              <input
                type="checkbox"
                checked={newEvent.Whole_day}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, Whole_day: e.target.checked })
                }
              />
            </div>
            <div>
              <label>Status</label>
              <input
                type="text"
                placeholder="Enter event status"
                value={newEvent.Status}
                onChange={(e) =>
                  setNewEvent({ ...newEvent, Status: e.target.value })
                }
              />
            </div>
            <div style={{ marginTop: "20px", margin: "auto" }}>
              <button type="button" onClick={handleAddEvent}>
                Save Changes
              </button>
            </div>
          </form>
        </CustomModal>

        <CustomModal show={showEventModal} onClose={handleCloseEventModal}>
          <h2>{selectedEvent && selectedEvent.title}</h2>
          <p>Description: {selectedEvent && selectedEvent.description}</p>
          <p>Service Name: {selectedEvent && selectedEvent.serviceName}</p>
          <p>
            Start:{" "}
            {selectedEvent &&
              moment(selectedEvent.start).format("MMMM Do YYYY, h:mm a")}
          </p>
          <p>
            End:{" "}
            {selectedEvent &&
              moment(selectedEvent.end).format("MMMM Do YYYY, h:mm a")}
          </p>
          <button onClick={handleCloseEventModal}>Close</button>
        </CustomModal>
      </div>
    </div>
  );
};

export default MyCalendar;
